import { deviceWidths } from '../utils/devices';

import useViewportDimensions from './useViewportDimensions';

function useIsMobile(): boolean {
  const viewportWidth = useViewportDimensions().width;
  return viewportWidth <= deviceWidths.tablet;
}

export default useIsMobile;
